import Vue from "vue";
import { postApi } from "@/utils/http";
import { _order, getReversed } from "@/utils/order";

export default {
  namespaced: true,
  state: { groups: [] },
  mutations: {
    setComputers(state, { g, computers }) {
      const index = state.groups.findIndex((x) => x.group.uid === g.uid);
      if (index !== -1) {
        const item = state.groups[index];
        Vue.set(state.groups[index], "computers", computers);
      }
    },

    edit(state, { g, obj }) {
      const index = state.groups.findIndex((x) => x.group.uid === g.uid);
      if (index !== -1) {
        const item = state.groups[index];
        Vue.set(state.groups[index], "group", { ...item.group, ...obj });
      }
    },
    add(state, group) {
      state.groups.unshift(group);
    },
    remove(state, g) {
      const index = state.groups.findIndex((x) => x.group.uid === g.uid);
      if (index !== -1) Vue.delete(state.groups, index);
    },
    set(state, groups) {
      state.groups = groups;
    },
    clear(state) {
      state.groups = [];
    },
  },
  actions: {
    async fetch({ commit, dispatch, state, rootState }, data) {
      if (state.groups.length === 0 || data.force) {
        const groups = await postApi("get/domainGroups", {
          domainUID: data.domainUID,
        });

        await dispatch(
          "settings/getUserSetting",
          { path: "groups", key: "order" },
          { root: true }
        );

        commit("set", _order(groups, rootState.settings.user.groups?.order));
      }
    },
    async fetchComputerGroups({ state }, data) {
      const result = await postApi("get/computerGroups", {
        domainUID: data.domainUID,
        computerUID: data.computerUID,
      });

      return result.filter((x) => x);
    },
    async add({ commit, state }, data) {
      const res = await postApi("create/computerGroup", {
        domainUID: data.domainUID,
        computerUIDs: data.computerUIDs,
        groupName: data.name,
        groupCss: data.css || "",
      });

      commit("add", res[0]);
      return res[0];
    },
    async edit({ commit, state }, { domainUID, groupUID, computerUIDs }) {
      const res = await postApi("set/computerGroup", {
        domainUID: domainUID,
        groupUID: groupUID,
        computerUIDs: computerUIDs,
      });

      commit("setComputers", { g: res[0].group, computers: res[0].computers });
    },
    async order({ dispatch, commit, state, rootState }, order) {
      const stateOrder = rootState.settings.user.groups?.order;
      order = getReversed(stateOrder, order);

      dispatch(
        "settings/setUser",
        { path: "groups", key: "order", value: order },
        { root: true }
      );

      commit("set", _order(state.groups, order));
    },
  },

  getters: {
    single: (state) => (groupUID) => {
      return state.groups.find((x) => x.group.uid === groupUID);
    },
    computerUIDs: (state) => (groupUID) => {
      const group = state.groups.find((x) => x.group.uid === groupUID);
      if (group && group.computers) return group.computers.map((x) => x.uid);
      else return [];
    },
    groups: (state) => (computerUID) => {
      return state.groups.filter(
        (group) =>
          group && group.computers.some((x) => x && x.uid === computerUID)
      );
    },
  },
  modules: {},
};
